module.exports = __webpack_public_path__ + "media/4_4.5a17f10c.wav";